import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';

export interface CIPXPillSwitcherOption {
  id: string | number;
  label?: string;
  icon?: string;
  tooltip?: string;
}

@Component({
  selector: 'cipx-pill-switcher',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltip],
  templateUrl: './pill-switcher.component.html',
  styleUrls: ['./pill-switcher.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CIPXPillSwitcherComponent),
      multi: true,
    },
  ],
})
export class CIPXPillSwitcherComponent implements ControlValueAccessor {
  @Input() title?: string;
  @Input() options: CIPXPillSwitcherOption[] = [];
  @Input() value: string | number | undefined;

  @Output() valueChange = new EventEmitter<string | number>();

  private onChange: (value: string | number) => void = () => {
    // No-op
  };
  private onTouched: () => void = () => {
    // No-op
  };

  writeValue(value: string | number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onSelect(option: CIPXPillSwitcherOption): void {
    if (this.value !== option.id) {
      this.value = option.id;
      this.valueChange.emit(option.id);
      this.onChange(option.id);
      this.onTouched();
    }
  }

  trackByFn(index: number, option: CIPXPillSwitcherOption): string | number {
    return option.id || index;
  }
}
